<template>
  <AuthShell kicker="انتخاب پروژه" code="V-03" title="کدام پروژه را مدیریت می‌کنید؟" description="داده‌ها و دسترسی‌های هر پروژه جدا هستند؛ بعداً از منوی حساب می‌توانید پروژه را عوض کنید.">
    <template #top><button type="button" class="auth-link" @click="logout">خروج</button></template>

    <div v-if="loading" class="picker-loading" role="status" aria-label="در حال دریافت پروژه‌ها"><span v-for="index in 3" :key="index"></span></div>
    <div v-else-if="error" class="auth-error" role="alert">
      {{ error }}
      <button type="button" class="auth-link retry" @click="loadProjects">تلاش دوباره</button>
    </div>
    <p v-else-if="!projects.length" class="picker-empty">هنوز دسترسی فعالی به پروژه‌ای برای این حساب ثبت نشده است.</p>
    <ul v-else class="project-list">
      <li v-for="(project, index) in projects" :key="project.id">
        <button type="button" class="project-option" @click="selectProject(project.id)">
          <span class="project-symbol" :class="'tone-' + (index % 3)" aria-hidden="true">
            <img v-if="project.image && !broken[project.id]" :src="project.image" alt="" @error="$set(broken, project.id, true)" />
            <template v-else>{{ (project.name_fa || project.name || 'و').charAt(0) }}</template>
          </span>
          <span class="project-copy"><strong>{{ project.name_fa || project.name || `پروژه ${project.id}` }}</strong><small v-if="project.name && project.name !== project.name_fa" class="vn-mono">{{ project.name }}</small></span>
          <svg class="project-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6" /></svg>
        </button>
      </li>
    </ul>
  </AuthShell>
</template>

<script>
import AuthShell from '@/components/AuthShell/index.vue';
import { logoutSession } from '@/api/apiServiceLayer';

export default {
  components: { AuthShell },
  data() { return { loading: true, error: '', projects: [], broken: {} }; },
  mounted() { this.loadProjects(); },
  methods: {
    async loadProjects() {
      this.loading = true;
      this.error = '';
      try {
        const res = await this.$ApiServiceLayer.get(this.$PATH.RELATIVE_PATH.GET.PROJECT_LISTS, this.$PATH.SERVICE_NAME.AUTH);
        if (res.status !== 200) {
          this.error = this.$ApiServiceLayer.getErrorMessage(res);
          return;
        }
        const assignments = Array.isArray(res.data) ? res.data : (res.data.results || []);
        const unique = new Map();
        assignments.forEach(assignment => {
          if (assignment.project && assignment.project.id) unique.set(assignment.project.id, assignment.project);
        });
        this.projects = Array.from(unique.values());
        if (this.projects.length === 1) this.selectProject(this.projects[0].id);
      } catch (_) {
        this.error = 'دریافت پروژه‌ها ممکن نشد. دوباره تلاش کنید.';
      } finally {
        this.loading = false;
      }
    },
    selectProject(id) {
      this.$STORE.commit('userConfig/setProjectInfo', id);
      this.$router.push({ name: 'dashboard' });
    },
    async logout() {
      await logoutSession();
      this.$router.push({ name: 'login' });
    },
  },
};
</script>
<style scoped>
.project-list { display: grid; gap: 12px; padding: 0; margin: 0; list-style: none; }
.project-option { display: flex; align-items: center; gap: 14px; width: 100%; min-height: 72px; padding: 12px 16px; border: 1.5px solid rgba(2, 11, 45, .16); border-radius: var(--r-xs); background: #FFFDF8; color: var(--navy-900); text-align: right; transition: transform .25s var(--ease-out), box-shadow .25s var(--ease-out), border-color .15s; }
.project-option:hover { border-color: var(--navy-900); box-shadow: 4px 4px 0 var(--navy-900); transform: translate(-2px, -2px); }
.project-symbol { display: grid; place-items: center; width: 46px; height: 46px; flex: none; overflow: hidden; border-radius: var(--r-xs); font-size: 20px; font-weight: 950; color: var(--navy-900); }
.project-symbol img { width: 100%; height: 100%; object-fit: cover; }
.tone-0 { background: var(--teal-500); } .tone-1 { background: var(--pink-500); color: var(--surface); } .tone-2 { background: var(--amber-500); }
.project-copy { display: grid; flex: 1; min-width: 0; line-height: 1.5; }
.project-copy strong { font-size: 15px; font-weight: 900; }
.project-copy small { font-size: 11px; color: #4A557E; }
.project-arrow { width: 22px; height: 22px; flex: none; fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; transition: transform .25s var(--ease-out); }
.project-option:hover .project-arrow { transform: translateX(-4px); }
.picker-loading span { display: block; height: 72px; margin-bottom: 12px; border-radius: var(--r-xs); background: linear-gradient(90deg, var(--paper-200), #F8F5EE, var(--paper-200)); background-size: 200% 100%; animation: shimmer 1.4s linear infinite; }
@keyframes shimmer { to { background-position: -200% 0; } }
.picker-empty { padding: 20px; border: 1.5px dashed rgba(2, 11, 45, .2); border-radius: var(--r-xs); color: #3D4870; }
.retry { margin-inline-start: 8px; }
</style>
